import React from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';

import { bemBlock } from '../../modules/bem';
import { ScrollArea } from '../scroll-area/ScrollArea';

import './Popover.less';

const block = bemBlock('popover');

function DefaultScrollArea({ children }: { children: React.ReactNode }) {
  return (
    <ScrollArea className={block('scroll-area')}>
      <ScrollArea.Viewport className={block('scroll-area-viewport')}>
        {children}
      </ScrollArea.Viewport>
      <ScrollArea.Scrollbar orientation="vertical" />
      <ScrollArea.Scrollbar orientation="horizontal" />
      <ScrollArea.Corner />
    </ScrollArea>
  );
}

type ContentOwnProps = {
  scrollArea?: React.ComponentType<{ children: React.ReactNode }>;
};

type ContentProps = React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> &
  ContentOwnProps;

const Content = React.forwardRef<React.ElementRef<typeof PopoverPrimitive.Content>, ContentProps>(
  function Content(
    { className, children, scrollArea: ScrollAreaWrapper = DefaultScrollArea, ...props },
    ref,
  ) {
    return (
      <PopoverPrimitive.Content ref={ref} className={block({ extra: className })} {...props}>
        <ScrollAreaWrapper>{children}</ScrollAreaWrapper>
      </PopoverPrimitive.Content>
    );
  },
);

const Header = React.forwardRef<React.ElementRef<'div'>, React.ComponentPropsWithoutRef<'div'>>(
  function Header({ className, ...props }, ref) {
    return (
      <>
        <div ref={ref} className={block({ element: 'header', extra: className })} {...props} />
        <div className={block('separator')} />
      </>
    );
  },
);

export const Popover = {
  Anchor: PopoverPrimitive.Anchor,
  Close: PopoverPrimitive.Close,
  Content,
  Header,
  Portal: PopoverPrimitive.Portal,
  Root: PopoverPrimitive.Root,
  Trigger: PopoverPrimitive.Trigger,
};
